// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Uv5X","col":"styles_col__2w62U","actions":"styles_actions__ngxFI","conflict":"styles_conflict__2Xs3V"};